<div
  class="enfaf-pdf-upload"
  (dragover)="onDragOver($event)"
  (dragleave)="onDragLeave($event)"
  (drop)="onDrop($event)"
  (click)="triggerFileInput()"
  [class.dragover]="isDragging()"
  [ngStyle]="{ minHeight: minHeight(), minWidth: minWidth(), width: width() }"
>
  @if (pdfPreviewSrc() && pdfPreviewSrc() !== '') {
    <img [src]="pdfPreviewSrc()" alt="Vista previa del PDF" style="object-fit: contain" />
    <div class="delete" (click)="removeFile($event)">
      <app-enfaf-icon svgIconName="trash-red" iconSize="21px" />
    </div>
    @if (isUploadingPdf()) {
      <div class="loader-overlay">
        <div class="loader"></div>
      </div>
    }
  } @else {
    @if (isUploadingPdf()) {
      <div class="loader-overlay">
        <div class="loader"></div>
      </div>
    } @else {
      <div class="content">
        <app-enfaf-icon svgIconName="image" iconSize="56px"></app-enfaf-icon>

        <div class="text-wrapper">
          <ng-content select="[slot-text]"></ng-content>

          <p class="text text-default">
            {{ hasFile() ? getDisplayFileName() : uploadText() }}
          </p>
        </div>
      </div>
      @if (hasFile()) {
        <div class="delete" (click)="removeFile($event)">
          <app-enfaf-icon svgIconName="trash-red" iconSize="21px" />
        </div>
      }
    }
  }
</div>

<input type="file" #fileInput style="display: none" [accept]="accept()" (change)="onFileSelected($event)" />

@if (errorMessage()) {
  <p class="error-message">{{ errorMessage() }}</p>
}
